import React from 'react';

import styled from 'styled-components';

import { getMoment } from '@libs/NwMoment';
import { datePickerBeforeOnChange, toISODate } from '@libs/NwMoment';

import CustomDatePicker from '@components/EventDateTimePicker/CustomDatePicker';
import FlexContainer from '@components/Gui/FlexContainer';

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 0.5rem 1rem;

    label {
        font-size: ${(props) => props.theme.FontSizeSm};
        color: ${(props) => props.theme.TextColorMuted};
        text-transform: uppercase;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
    }

    .check-in {
        flex: 1;
    }
    .check-out {
        flex: 1;
    }
`;

const CheckDatePeriodPicker = ({ value, onChange }) => {
    const onFromDateChange = (val) => {
        onChange({
            FromDate: val,
            ToDate: val,
        });
    };
    const onToDateChange = (val) => {
        onChange({
            ...value,
            ToDate: val,
        });
    };
    const disableCheckOutDate = (beforeDate) => (date) => {
        if (beforeDate && toISODate(beforeDate) > toISODate(date)) {
            return true;
        }
        return false;
    };
    return (
        <Wrapper>
            <div className="check-in">
                <label>Check In</label>
                <CustomDatePicker
                    name="FromDate"
                    value={value.FromDate ? getMoment(value.FromDate) : null}
                    format="MMM DD, YYYY"
                    style={{ width: '100%' }}
                    getCalendarContainer={(triggerNode) => triggerNode.parentNode}
                    manipulateValue={datePickerBeforeOnChange}
                    onChange={onFromDateChange}
                />
            </div>
            <div className="check-out">
                <label>Check Out</label>
                <CustomDatePicker
                    name="ToDate"
                    value={value.ToDate ? getMoment(value.ToDate) : null}
                    format="MMM DD, YYYY"
                    style={{ width: '100%' }}
                    getCalendarContainer={(triggerNode) => triggerNode.parentNode}
                    manipulateValue={datePickerBeforeOnChange}
                    onChange={onToDateChange}
                    disabledDate={disableCheckOutDate(value.FromDate)}
                />
            </div>
        </Wrapper>
    );
};

export default CheckDatePeriodPicker;
